<template>
    <div style="width:100%">
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-form style="width:100%" ref="organizationForm" @submit="save" onsubmit="return false">
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex md4>
                        <v-text-field counter="100" label="Organization Name" v-model="organization.name"
                                      ref="organizationName"
                                      :rules="serverValidation('name','Organization Name')"></v-text-field>
                    </v-flex>
                    <v-flex md4>
                        <v-text-field counter="100"
                                      label="Tip Submission E-Mail"
                                      v-model="organization.tipEmail"
                                      :rules="serverValidation('tipEmail','Tip Submission E-Mail')">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 md4 v-if="$permissionHolder.hasPermission('GLOBAL_ADMIN')">
                        <v-select :items="cadConfigurations"
                                  label="CAD Configuration"
                                  item-text="description"
                                  v-model="cadConfigurationId"
                                  required
                                  item-value="id"></v-select>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-btn outlined type="submit" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                    <organization-send-new-user-notifications :organizationId="organization.id"/>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    const NO_CAD_CONFIG = -9999;
    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'
    import OrganizationContactLists from '@/components/organization/contacts/OrganizationContactLists';
    import OrganizationSendNewUserNotifications from "./OrganizationSendNewUserNotifications";
    export default {
        components: {OrganizationSendNewUserNotifications, OrganizationContactLists},
        inject: ['getProvidedOrganization','refreshOrganization'],
        mixins:[validationMixin],
        data() {
            return {
                cadConfigurationId : null,
                originalCadConfigurationId: null,
                organization: {},
                cadConfigurations : [],
                applications:null,
                isEdit : false,
                overlay : false
            }
        },
        created() {

        },
        mounted() {
            this.get().then(()=>{
                // post processing if needed (not now)
            });
        },
        methods: {
            get() {
                return new Promise((resolve,reject) => {
                    this.organization = this.getProvidedOrganization();
                    this.$refs.organizationName.focus();
                    if (this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                        this.cadConfigurationId =  this.organization.cadConfigurationId;
                        this.originalCadConfigurationId = this.organization.cadConfigurationId;
                    }


                    if (this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                        api.cadConfig.search().then((data) => {
                            this.cadConfigurations = data.list;
                            this.cadConfigurations.unshift({
                                id:NO_CAD_CONFIG,
                                description:'- No Configuration -'
                            })
                            resolve();
                        });
                    } else {
                        resolve();
                    }
                });
            },
            showSuccess() {
                this.$root.$emit('globalMessage','Organization Saved');
            },
            save() {
                this.overlay = true;
                let promises = [];

                promises.push(new Promise((resolve,reject) => {
                    api.organization.patch(this.organization).then((org) => {
                        resolve();
                    }, (error) => {
                        if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                            this.$refs.organizationForm.validate();
                        }
                        reject(error);
                    });
                }));

                if (this.$permissionHolder.hasPermission('GLOBAL_ADMIN')) {
                    if (this.originalCadConfigurationId && (this.cadConfigurationId != this.originalCadConfigurationId)
                    ) {
                        promises.push(new Promise((resolve,reject) => {
                            api.organization.cad.delete(this.organization.id,this.originalCadConfigurationId).then((result) => {
                                setTimeout(() => {
                                    resolve(result);
                                },2000);
                            }, (error) => {
                                reject(error);
                            });
                        }));
                    }

                    if (this.cadConfigurationId && this.cadConfigurationId != NO_CAD_CONFIG) {
                        promises.push(new Promise((resolve, reject) => {
                            api.organization.cad.post(this.organization.id, this.cadConfigurationId).then((result) => {
                                resolve(result);
                            }, (error) => {
                                reject(error);
                            });
                        }));
                    }


                }

                Promise.all(promises).then(() => {
                    this.$root.$emit('globalMessage','Organization Updated');
                    this.refreshOrganization().then(() => {
                        this.get();
                    });
                }, () => {
                    this.$root.$emit('globalError','Error Updating Organization');
                }).finally(() => {
                    this.overlay = false;
                })
            }
        }

    }

</script>